import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function DevBoxNote({ slug }: { slug: string }): JSX.Element {
    if (slug !== "devbox") {
        return null;
    }
    return (<Wrapper aria-label="DevBox (Internal) Information">
        <p> <b>Please note before reporting!</b></p>
        <p>
            <ul>
                <li><b>Only report bugs or feature suggestions on this page</b>, reviewed weekly by the team.</li>
                <li><b>If you&#39;re blocked, see </b> <a href="https://learn.microsoft.com/en-us/azure/dev-box/how-to-troubleshoot-repair-dev-box" target="_blank" rel="noreferrer">troubleshooting guidance</a></li>
                <li><b>For immediate support</b> on blocking issues contact <a href="https://ms.portal.azure.com/#view/Microsoft_Azure_Support/HelpAndSupportBlade/~/overview" target="_blank" rel="noreferrer">Help + support - Microsoft Azure</a></li>
                <li><b>Microsoft employees and vendors:</b>
                    <ul>
                        <li> <b>For Microsoft internal bugs or feature suggestions go here</b> <a href="https://developercommunity.microsoft.com/devboxinternal" target="_blank" rel="noreferrer">Microsoft Developer Community</a></li>
                        <li><b>For immediate support</b> on blocking issues contact <a href="https://aka.ms/techweb" target="_blank" rel="noreferrer">Techweb</a> </li>
                    </ul>
                </li>
            </ul>
        </p>
    </Wrapper>);
}

const Wrapper = styled.div`
    padding: 2rem;
    margin: 2rem 0;
    border: 0.1rem solid var(--color-info);
    border-top: 0.4rem solid var(--color-info);
    border-radius: 0.2rem;
    box-shadow: 0px 0.3px 0.9px rgb(0 0 0 / 11%),0px 1.6px 3.6px rgb(0 0 0 / 13%);
    background-color: var(--color-surface);

    ul {
        padding-inline-start: 4rem;
        margin-block-start: 1em;
        margin-block-end: 1em;

        li {
            display: list-item;
             ul {
                padding-inline-start: 1.0rem; 
                margin-block-start: 0.5em; 
                margin-block-end: 0.5em;
            }
        }
    }
`;
